<div>
  @if (officeholdersViewModel().officeholderDetails) {
    <app-officeholder-profile
      [officeholder]="officeholdersViewModel().officeholderDetails!"
      [disableControls]="disableControls()"
      [isPendingChangesVisible]="officeholdersViewModel().isPendingChangesVisible"
      (profileViewChange)="setOfficeholderDetailsState()"
      (ceaseRegisteredAgent)="ceaseRegisteredAgent.emit($event)"
      (companyChangePartyName)="companyChangePartyName.emit($event)"
      (changeOfficerAddress)="changeOfficerAddress.emit($event)"
      (editOfficer)="editOfficer($event)"
    />
  } @else {
    <div class="card-body p-0">
      <app-grid-client-side
        [rowData]="officeholdersViewModel().officeholdersViewModel"
        [colDefs]="$any(colDefs())"
        [gridOptions]="gridOptions"
        [suppressRowClickSelection]="true"
        [suppressCellFocus]="true"
        [paginationPageSizeSelector]="true"
        [excelStyles]="excelStyles"
        (gridReady)="onGridReady($event)"
        (select)="onSelectOfficeholderModelRow($event)"
      >
        @if (officeholdersViewModel().isShowPastOfficeholdersToggleVisible) {
          <div class="grid-controls-middle h-100 d-flex flex-grow-1">
            <label class="d-flex align-items-center gap-2 mb-0">
              <app-toggle-button
                [switched]="officeholdersViewModel().isPastOfficeholdersVisible"
                (switchBtn)="setIsPastOfficeholdersVisible($event)"
              />

              <span class="font-size-14">Show Past Officers</span>
            </label>
          </div>
        }

        <div class="grid-controls-end">
          <div ngbDropdown>
            <button
              ngbDropdownToggle
              type="button"
              title="Export"
              class="btn btn-secondary btn-icon"
            >
              <i class="icon ic-download-20"></i>
            </button>


            <div ngbDropdownMenu class="common-dropdown-menu">
              <button
                ngbDropdownItem
                type="button"
                (click)="onExportOfficeholders(ExportTypeEnum.EXCEL)"
              >
                Export to xlsx
              </button>

              <button
                ngbDropdownItem
                type="button"
                (click)="onExportOfficeholders(ExportTypeEnum.PDF)"
              >
                Export to pdf
              </button>
            </div>
          </div>
        </div>
      </app-grid-client-side>
    </div>
  }
</div>
